const workshopButton = document.querySelector('#workshop-button');
const workshopWrapper = document.querySelector('.workshop-wrapper');
const workshopSlider = document.querySelector('.workshop-slider');
const nextButton = document.querySelector('#workshop-next-button');
const previousButton = document.querySelector('#workshop-previous-button');
const workshopSlides = document.querySelectorAll('.workshop-slide');

let step = 0;

const checkRequiredFields = () => {
    const currentSlide = workshopSlides[step];
    const requiredInputs = currentSlide.querySelectorAll('input[required], textarea[required]');
    
    const allFieldsFilled = Array.from(requiredInputs).every(input => {
        return input.value.trim() !== '';
    });

    if (!allFieldsFilled) {
        nextButton.classList.add('disabled');
    } else {
        nextButton.classList.remove('disabled');
    }
};

const addInputListeners = () => {
    const slides = document.querySelectorAll('.workshop-slide');
    slides.forEach(slide => {
        const inputs = slide.querySelectorAll('input[required], textarea[required]');
        inputs.forEach(input => {
            input.addEventListener('input', checkRequiredFields);
        });
    });
};

addInputListeners();
checkRequiredFields();

// Display the workshop wrapper
workshopButton.addEventListener('click', () => {
    
    if(workshopWrapper.classList.contains('active')) {
        return
    }
    workshopWrapper.classList.add('active');
    setTimeout(() => {
        const offsetTop = workshopWrapper.offsetTop;
        window.scrollTo({
            top: offsetTop,
            behavior: 'smooth'
        });
    }, 100);
});

const updateSliderPosition = () => {
    workshopSlider.style.transform = `translateX(-${step * 100}%)`;
};

nextButton.addEventListener('click', () => {
    step++;
    updateSliderPosition();
});

previousButton.addEventListener('click', () => {
    step--;
    updateSliderPosition();
});

if(step === 0) {
    previousButton.classList.add('hide');
}

// Disabled tab key
workshopWrapper.addEventListener('keydown', (e) => {
    if(e.key === 'Tab') {
        e.preventDefault();
    }
});

